import React, { Component } from 'react';
import { Row, Col, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import BlockUi from 'react-block-ui';
import moment from 'moment';
import { getAPI } from '../../Base/API';
import { handleNotification } from '../../Base/Common/Notification';

//Version history of a template (previous states stored by the audit table), same model as the GMS Stripo versions modal.
//Selecting a version previews it; Restore loads it into the editor (nothing is persisted until Save Design).
class TemplateVersions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            block: true,
            versions: [],
            selectedVersion: null,
            pageIndex: 0,
            pageSize: 10,
            totalItems: 0
        };
    }

    componentDidMount() {
        this.getVersions();
    }

    getVersions = () => {
        this.setState({ block: true });

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                const errorMessage = [{ message: error.message, stack: error.stack, messageType: 'danger' }];
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }

                const versions = data.response || [];

                this.setState({
                    versions,
                    totalItems: typeof data.count === 'number' ? data.count : versions.length,
                    selectedVersion: versions[0] || null,
                    block: false
                });
            }
            else this.setState({ block: false });
        }, `/api/Voucher/v1/Config/notificationTemplates/${this.props.templateId}/versions?pageSize=${this.state.pageSize}&pageIndex=${this.state.pageIndex}`);
    }

    changePage = (offset) => {
        if (this.state.block) {
            return;
        }

        this.setState(prevState => ({
            block: true,
            pageIndex: Math.max(0, prevState.pageIndex + offset)
        }), this.getVersions);
    }

    render() {
        const { versions, selectedVersion, pageIndex, pageSize, totalItems } = this.state;

        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="xl">
                <ModalHeader toggle={this.props.toggle}>
                    <FormattedMessage id="TemplateVersions.Title" />
                </ModalHeader>
                <ModalBody>
                    <BlockUi tag="div" blocking={this.state.block}>
                        {versions.length > 0 ?
                            <Row>
                                <Col md={4} style={{ maxHeight: '65vh', overflowY: 'auto' }}>
                                    {versions.map((version, index) =>
                                        <div
                                            key={index}
                                            className={`shadow pointer overbglight p-2 mb-2 ${selectedVersion?.version === version.version ? 'border border-host' : ''}`}
                                            onClick={() => this.setState({ selectedVersion: version })}
                                        >
                                            <Row>
                                                <Col>
                                                    <b><FormattedMessage id="TemplateVersions.Version" /> {version.version}</b>
                                                </Col>
                                                <Col className="text-right">
                                                    {moment(version.updatedAt).format('YYYY-MM-DD HH:mm')}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="text-muted">
                                                    {version.updatedBy}
                                                </Col>
                                            </Row>
                                        </div>
                                    )}

                                    <Row className="align-items-center">
                                        <Col>
                                            <Button className="btn-host btn-sm" disabled={pageIndex === 0} onClick={() => this.changePage(-1)}>
                                                <i className="fas fa-angle-left" />
                                            </Button>
                                        </Col>
                                        <Col className="text-right">
                                            <Button className="btn-host btn-sm" disabled={(pageIndex + 1) * pageSize >= totalItems} onClick={() => this.changePage(1)}>
                                                <i className="fas fa-angle-right" />
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={8}>
                                    {selectedVersion ?
                                        <>
                                            <iframe
                                                title="templateVersionPreview"
                                                sandbox="allow-same-origin"
                                                style={{ width: '100%', height: '60vh', border: '1px solid #ccc', backgroundColor: '#ffffff' }}
                                                srcDoc={`<style>${selectedVersion.templateCss || ''}</style>${selectedVersion.templateJson || ''}`}
                                            />
                                            <Row className="mt-2">
                                                <Col className="text-right">
                                                    <Button className="btn-host btn-sm" onClick={() => this.props.onRestore(selectedVersion)}>
                                                        <i className="fas fa-history mr-1" /><FormattedMessage id="TemplateVersions.Restore" />
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </>
                                    : ''}
                                </Col>
                            </Row>
                            :
                            <div className="text-center py-4">
                                <FormattedMessage id="TemplateVersions.NoVersions" />
                            </div>
                        }
                    </BlockUi>
                </ModalBody>
            </Modal>
        );
    }
}

export default TemplateVersions;
